import { render, staticRenderFns } from "./compSet.vue?vue&type=template&id=10965322&scoped=true"
import script from "./compSet.vue?vue&type=script&lang=js"
export * from "./compSet.vue?vue&type=script&lang=js"
import style0 from "./compSet.vue?vue&type=style&index=0&id=10965322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10965322",
  null
  
)

export default component.exports